const en = {
  nav: {
    features: "Features",
    dashboard: "Dashboard",
    howItWorks: "How It Works",
    download: "Download",
    login: "Login",
  },

  hero: {
    badge: "Expense management for companies",
    title: "Expense management,\nmade simple.",
    description:
      "Scan, submit, track. TicketBox takes care of the rest — from the employee's receipt to the accountant's reimbursement.",
    descriptionSecondary:
      "Snap a photo of your receipt and let OCR and AI fill in the expense report for you, then track its validation and reimbursement with full transparency.",
    ctaPrimary: "Download the app",
    ctaSecondary: "See how it works",
    mockupAlt: "TicketBox mobile app home screen",
  },

  scan: {
    tag: "SMART RECEIPT SCANNING",
    title: "Let AI fill out your expense reports",
    description:
      "Photograph your receipt and TicketBox automatically extracts the amount, date and merchant using OCR and AI — no manual entry.",
    bullets: [
      "Instant OCR text extraction",
      "AI-powered field detection",
      "Editable before you submit",
    ],
    resultLabel: "Result",
    result: "Less paperwork, faster expense reports.",
    mockupAlt: "AI scanning a receipt in the TicketBox app",
  },

  workflow: {
    tag: "SIMPLE, TRACKED PROCESS",
    title: "How it works",
    description:
      "Every expense follows a clear, transparent path — from submission to reimbursement.",
    steps: [
      {
        title: "Submit",
        description:
          "The employee photographs their receipt and submits the expense in seconds.",
      },
      {
        title: "Validate",
        description:
          "The accountant or external accountant approves the expense, or rejects it with an explanatory note.",
      },
      {
        title: "Reimburse",
        description:
          "Once reimbursed by the company, the expense is archived with its full history.",
      },
    ],
  },

  dashboard: {
    tag: "WEB DASHBOARD",
    title: "Manage your company's expenses from one screen",
    description:
      "Accountants and managers get a dedicated web dashboard to review, validate or reject expenses, and track reimbursements — alongside the mobile app.",
    homeAlt: "TicketBox web dashboard overview",
    expensesAlt: "Expense management screen in the TicketBox web dashboard",
    zoomHint: "Click to zoom",
  },

  download: {
    title: "Download the app",
    description:
      "Built for companies and their accountants: roles, a validation workflow, and a complete history, from the employee to the external accountant.",
    badgeAlt: "Get it on Google Play",
  },

  footer: {
    dashboardLink: "Dashboard",
    privacyLink: "Privacy Policy",
  },

  privacy: {
    title: "TicketBox Privacy Policy",
    effectiveDateLabel: "Effective date:",
    effectiveDate: "July 13, 2026",
    backLink: "← Back",
    sections: [
      {
        title: "1. Introduction",
        body: "This Privacy Policy describes how TicketBox collects, uses and protects your personal data when you use the TicketBox mobile application, the TicketBox web dashboard, and this website. By using the service, you acknowledge that you have read this policy.",
      },
      {
        title: "2. Data Controller",
        body: "The data controller is TicketBox, operated by Ygalaad. For any questions about your personal data, you can contact us at support@ygalaad.com.",
      },
      {
        title: "3. Data We Collect",
        body: "We may collect the following categories of data: account information (first name, last name, email address, encrypted password and phone number where applicable, needed to create your account); professional data (your company affiliation, role — employee, accountant, manager, external accountant — and line manager); expense report data (amounts, dates, categories, merchants, notes, validation statuses and receipt photos imported or taken via the camera); and technical data (authentication tokens, session identifiers, IP address, device type, app version and error logs, necessary for the service to function and stay secure).",
      },
      {
        title: "4. Purposes of Processing",
        body: "Your data is processed to: create and manage your account and assign the correct role within your company; enable entry, submission and tracking of your expense reports; extract information from your receipts automatically; submit expenses for validation, rejection or reimbursement within your organization; ensure the security, reliability and maintenance of the service; and respond to your support requests.",
      },
      {
        title: "5. Legal Basis",
        body: "Processing of your data is based on performance of the contract between TicketBox and its user, TicketBox's legitimate interest in ensuring security and improving the service, and, where applicable, compliance with legal obligations relating to accounting or professional expense management.",
      },
      {
        title: "6. Data Recipients",
        body: "Your expense data (including receipt photos) is accessible to administrators of your organization holding an authorized role — accountant, manager or external accountant — for the purpose of validating, rejecting or reimbursing expenses. It may also be processed by our technical providers (hosting, infrastructure) strictly to the extent necessary to provide the service, under confidentiality agreements. We do not sell your personal data to third parties.",
      },
      {
        title: "7. Data Retention",
        body: "Your data is retained for the duration of your use of the service, then archived or deleted in accordance with applicable legal obligations and the retention rules defined by your organization. Inactive account data may be deleted after a prolonged period of inactivity, subject to legal deadlines. You can also request deletion of your account and data at any time by contacting your company manager or Ygalaad directly.",
      },
      {
        title: "8. Your Rights",
        body: "Under the General Data Protection Regulation (GDPR), you have the right of access, rectification, erasure, restriction of processing, portability and objection regarding your personal data. You can exercise these rights by writing to support@ygalaad.com. You also have the right to lodge a complaint with your local data protection authority.",
      },
      {
        title: "9. Security",
        body: "TicketBox implements appropriate technical and organizational measures to protect your data against unauthorized access, loss, alteration or disclosure, including encrypted authentication (JWT tokens with secure refresh) and encrypted communication with our servers. Access to the camera and photo gallery is requested only when you choose to import or photograph a receipt. No method of transmission or storage can be guaranteed to be completely secure.",
      },
      {
        title: "10. Children's Privacy",
        body: "The service is intended for professional use and is not directed at individuals under the age of 16. We do not knowingly collect data from minors.",
      },
      {
        title: "11. Changes to This Policy",
        body: "TicketBox reserves the right to modify this Privacy Policy at any time. The effective date at the top of this page reflects the latest revision. Continued use of the service after a change constitutes acceptance of the updated policy.",
      },
      {
        title: "12. Contact Us",
        body: "For any questions about this Privacy Policy or your personal data, contact us at: support@ygalaad.com — Ygalaad, 230 Route des Dolines, 06560 Valbonne, France.",
      },
    ],
  },
};

export default en;
